export const PARTY_SUGGEST_DEBOUNCE_MS = 400;
export const PARTY_SUGGEST_MIN_QUERY_LENGTH = 3;
export const PARTY_SUGGEST_STALE_TIME_MS = 30_000;
